export default "__VITE_ASSET__D9Q_WGd7__"